<div class="of-callout" [ngClass]="'of-callout--' + type">
  <mat-icon class="of-callout__icon">{{ icon }}</mat-icon>
  <span class="of-callout__message">{{ message }}</span>
</div>
